import type { ElementType, PropsWithChildren, ReactNode } from "react";
import { IoChevronForward } from "react-icons/io5";

import type { PolymorphicProps } from "shared/types";

import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
  title: ReactNode;
  description: ReactNode;
  icon: ReactNode;
  disabled?: boolean;
  rightIconClassName?: string;
  rightIcon?: ReactNode;
};
export const Item = <E extends ElementType>(
  props: PolymorphicProps<E, PropsWithChildren<Props>>
) => {
  const {
    className,
    as = "div",
    children,
    rightIconClassName,
    icon,
    title,
    description,
    rightIcon,
    disabled,
    ...restProps
  } = props;
  const Comp = as;
  return (
    <Comp
      className={cn(
        "group border-dark-grey flex flex-col gap-y-3 rounded-xl border p-3 transition-colors hover:brightness-125",
        disabled && "bg-oil pointer-events-none opacity-50",
        className
      )}
      {...restProps}
    >
      <div className="flex w-full cursor-pointer items-center">
        <div className="size-8 shrink-0 text-white">{icon}</div>

        <div className="ml-4 flex grow flex-col">
          <h3 className="text-lg leading-5.5 font-medium tracking-[0.4px]">
            {title}
          </h3>
          <p className="text-pale-grey mt-0.5 flex">{description}</p>
        </div>

        {rightIcon ?? (
          <IoChevronForward
            className={cn(
              "text-pale-grey ml-auto size-5.5 shrink-0 transition-colors group-hover:text-white",
              rightIconClassName
            )}
          />
        )}
      </div>

      {children}
    </Comp>
  );
};
